var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6312 4.76853C16.3898 4.75049 16.0785 4.75 15.6088 4.75H14.3809C13.9667 4.75 13.6309 4.41421 13.6309 4C13.6309 3.58579 13.9667 3.25 14.3809 3.25H15.6357C16.0714 3.24999 16.4391 3.24998 16.743 3.2727C17.0624 3.29657 17.365 3.34825 17.6605 3.47926C18.1166 3.68148 18.5069 4.00766 18.7852 4.42132C18.966 4.69002 19.0682 4.979 19.1449 5.28811C19.2178 5.5816 19.2784 5.94085 19.3499 6.36488L20.3586 12.3459C20.3953 12.5635 20.3343 12.7863 20.1918 12.9548C20.0493 13.1234 19.8398 13.2206 19.619 13.2206C17.1319 13.2206 15.1309 15.2107 15.1309 17.6471C15.1309 18.0613 14.7952 18.3971 14.3809 18.3971H7.86358C7.48221 19.6157 6.34437 20.5 5 20.5C3.34315 20.5 2 19.1569 2 17.5C2 15.8431 3.34315 14.5 5 14.5C6.45034 14.5 7.66029 15.5292 7.93939 16.8971H13.6784C14.0147 14.2579 16.1026 12.1673 18.7426 11.7837L17.8753 6.64136C17.7981 6.18308 17.7466 5.8808 17.6892 5.64959C17.6341 5.42779 17.5857 5.32551 17.5407 5.25874C17.4211 5.08096 17.2522 4.93904 17.0526 4.85054C16.9761 4.81665 16.8634 4.78588 16.6312 4.76853Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.5C22.5 19.1569 21.1569 20.5 19.5 20.5C17.8431 20.5 16.5 19.1569 16.5 17.5C16.5 15.8431 17.8431 14.5 19.5 14.5C21.1569 14.5 22.5 15.8431 22.5 17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.ea5fae78744380f01c213958c9012f26.svg";
export { ForwardRef as ReactComponent };